import { Button } from './Button'

type LoadMoreFooterProps = {
  shown: number
  total: number
  hasMore: boolean
  loading?: boolean
  loadingMore?: boolean
  onLoadMore: () => void
}

export function LoadMoreFooter({
  shown,
  total,
  hasMore,
  loading = false,
  loadingMore = false,
  onLoadMore,
}: LoadMoreFooterProps) {
  if (total === 0) return null

  return (
    <div className="mt-4 flex flex-col items-center gap-3 border-t border-border pt-4">
      <p className="text-xs text-muted-foreground">
        Showing <span className="font-medium text-foreground">{shown}</span> of{' '}
        <span className="font-medium text-foreground">{total}</span>
      </p>
      {hasMore ? (
        <Button
          type="button"
          variant="secondary"
          size="sm"
          disabled={loading || loadingMore}
          onClick={() => void onLoadMore()}
        >
          {loadingMore ? 'Loading…' : 'Load more'}
        </Button>
      ) : shown > 0 ? (
        <p className="text-xs text-muted-foreground">All items loaded.</p>
      ) : null}
    </div>
  )
}
